import React from "react";
import { useNavigate } from "react-router-dom";
import lodash from "lodash";
import moment from "moment";
//outsource
import { Row, Col, Table, Pagination } from "antd";
import {
  getDataRows,
  getHeaderRows,
} from "../../../utils/refine.income_by_staff_report";
import { useDispatch } from "react-redux";
import { setDate, setDateLabel } from "../../../store/var/var.action";
import numeral from "numeral";

//components

const IncomeByStaffTable = (props) => {
  // -------------------------- VAR --------------------------
  const { reportData } = props;
  const navigate = useNavigate();
  const totalIncome = lodash.sumBy(reportData, (staff) => staff.income);
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  // -------------------------- FUNCTION --------------------------
  const sortData = (data) => {
    return data.slice().sort((a, b) => b.date - a.date);
  };

  const navigateToDetailIncome = (record) => {
    const shopId = record?.branch;
    const date = record?.date && moment(record?.date);
    const labelDate = date?.format("DD/MM/YYYY");
    dispatch(setDate({ data: date }));
    dispatch(
      setDateLabel({ data: labelDate }, () => {
        const href = `/report/cashup/${shopId}/income-by-staff/detail`;
        navigate(href);
      })
    );
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- RENDER --------------------------
  // console.log(reportData);
  const dataRange = getDataRows(sortData(reportData));

  const columns = getHeaderRows();
  const finalIncome = numeral(totalIncome).format("0,0.00");
  const total = dataRange.length;
  // -------------------------- MAIN --------------------------
  return (
    <Row>
      <Col style={{ marginTop: 5 }} align="right" span={24}>
        Total:{" "}
        <span style={{ color: "#1a76d2", fontWeight: "bold" }}>
          ${finalIncome}
        </span>
      </Col>
      <Col span={24}>
        <Table
          bordered
          columns={columns}
          dataSource={dataRange}
          // tắt điều hướng đến trang income by Staff để tránh trường hợp edit income, trong khi cashup record không được cập nhật lại.
          // onRow={(record) => {
          //   return { onClick: () => navigateToDetailIncome(record) };
          // }}
          pagination={{
            position: ["bottomRight"],
            pageSize: 50,
            defaultCurrentPage: 1,
            total: { total },
          }}
        />
      </Col>
    </Row>
  );
};

export default IncomeByStaffTable;
